import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import PropTypes, { any } from 'prop-types'
import { useFeatures } from 'flagged'
import FilledAccountIcon from '../../../../../assets/images/filled-account-icon.svg'
import { Box, Button, Menu, IconButton, Typography } from '../../../../mui/Core/index'
import { ArrowDropDown, ArrowDropUp } from '../../../../mui/Icons'
import { signOut } from '../../../../../api/userauthentication/signout'
import { purgePersistedState } from '../../../../../app/store'
import { useTheme } from '../../../../mui/Styles/index'
import { logoutUser } from '../../../../../api/user/authentication'
import Constants from '../../../../../constants/en.json'
import { routePaths } from '../../../../../constants/routes'

function UserMenu(props) {
  const theme = useTheme()
  const { fullName, userLinks } = props
  const navigate = useNavigate()
  const features = useFeatures()
  const [anchorElUser, setAnchorElUser] = useState(null)

  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget)
  }

  const onLogoutCallback = () => {
    purgePersistedState()
    localStorage.clear()
    sessionStorage.clear()
    navigate(routePaths.LOGIN)
  }

  const handleLogout = async () => {
    if (features.isUserServiceEnabled) {
      try {
        await logoutUser()
        onLogoutCallback()
      } catch (exception) {
        onLogoutCallback()
      }
    } else {
      signOut()
        .then(() => onLogoutCallback())
        .catch(() => onLogoutCallback())
    }
    setAnchorElUser(null)
  }

  const handleCloseUserMenu = () => {
    setAnchorElUser(null)
  }

  const handleNavigate = (navigateToPath) => {
    navigate(navigateToPath)
  }

  const userSettingsStyle = {
    mr: '40px',
  }

  const iconButtonStyle = {
    paddingRight: '0px',
    width: 'auto',
  }

  const userNameStyle = {
    fontFamily: 'AtlasTypewriterRegular',
    textTransform: 'Uppercase',
    letterSpacing: '1.28px',
    marginLeft: '9px',
    color: theme.palette.common.white,
  }

  const menuStyle = {
    mt: '60px',
    minWidth: '200px',
    '& .MuiMenu-paper': {
      borderRadius: '4px',
    },
    '& ul': {
      padding: '4px 0',
    },
  }

  const menuLinksStyle = {
    fontFamily: 'AtlasGroteskRegular',
    fontSize: '16px',
    padding: '14px 12px',
    color: theme.palette.common.black,
    display: 'block',
    textAlign: 'right',
    height: '48px',
    letterSpacing: 0,
    borderRadius: 0,
    textDecoration: 'none',
    '&:hover': {
      backgroundColor: `${theme.palette.grey[400]} !important`,
      textDecoration: 'none',
    },
  }

  const arrowDropDownStyle = {
    marginTop: '7px',
    marginLeft: '10px',
  }

  return (
    <Box sx={userSettingsStyle}>
      <IconButton
        size='large'
        aria-label='account-of-current-user'
        aria-controls='menu-appbar'
        aria-haspopup='true'
        onClick={handleOpenUserMenu}
        color='inherit'
        disableRipple
        sx={iconButtonStyle}
      >
        <img alt='filled-account-icon' src={FilledAccountIcon} />
        <Typography sx={userNameStyle}>{fullName}</Typography>
        {anchorElUser ? (
          <ArrowDropUp sx={arrowDropDownStyle} />
        ) : (
          <ArrowDropDown sx={arrowDropDownStyle} />
        )}
      </IconButton>
      <Menu
        sx={menuStyle}
        id='menu-appbar'
        anchorEl={anchorElUser}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        keepMounted
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        open={Boolean(anchorElUser)}
        onClose={handleCloseUserMenu}
      >
        {userLinks.map((link) => {
          return (
            <Button key={link.title} sx={menuLinksStyle} onClick={() => handleNavigate(link.path)}>
              {link.title}
            </Button>
          )
        })}
        <Button
          variant='text'
          fullWidth
          disableRipple
          sx={menuLinksStyle}
          onClick={handleLogout}
          href='#'
        >
          {Constants.genericNav.userLinks.LOGOUT}
        </Button>
      </Menu>
    </Box>
  )
}

UserMenu.propTypes = {
  userLinks: PropTypes.arrayOf(PropTypes.objectOf(any)).isRequired,
  fullName: PropTypes.string.isRequired,
}

export default UserMenu
